import React from "react";

const ListEmptyText = ({ text }) => {
  return <strong className="d-block mt-5 mb-5 h-full w-full mx-auto text-gray text-center fs-md">{text}</strong>;
};

export default ListEmptyText;
